import { render, staticRenderFns } from "./WatchList.vue?vue&type=template&id=1b8ed864&scoped=true"
import script from "./WatchList.vue?vue&type=script&lang=ts"
export * from "./WatchList.vue?vue&type=script&lang=ts"
import style0 from "./WatchList.vue?vue&type=style&index=0&id=1b8ed864&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ed864",
  null
  
)

export default component.exports